import { computed } from "vue";
const paymentMethodList = computed(() => {
    return Object.entries(window.marque.ui.paymentMethods).map(([key, value]) => {
        return {
            value: key,
            label: value
        };
    });
});
const paymentMethodListWithout = (methods) => {
    return computed(() => {
        return paymentMethodList.value.filter(item => {
            return !(methods.indexOf(item.value) > -1);
        });
    });
};
export { paymentMethodList, paymentMethodListWithout };
